import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import './css/style.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import CurrentDate from './CurrentDate'
import './language/i18n';
import { store } from './app/store'
import { Provider } from 'react-redux'

import "bootstrap/dist/css/bootstrap.css";
import "./assets/scss/paper-dashboard.scss?v=1.3.0";
import "./assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";


CurrentDate();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
);

reportWebVitals();
